import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSystem } from "../../reducers/systemSlice";
import { 
  HomeOutlined, 
  VideoCameraOutlined, 
  SafetyOutlined,
  ClockCircleOutlined,
  FileTextOutlined,
  AppstoreOutlined
} from "@ant-design/icons";

const MobileBottomNav = () => {
  const dispatch = useDispatch();
  const selectedSystem = useSelector((state) => state.system.system);

  const handleSystemChange = (value) => {
    dispatch(setSystem(value));
  };

  const navItems = [
    {
      key: 1,
      icon: <VideoCameraOutlined />,
      label: "VMS",
      color: "#1890ff"
    },
    {
      key: 2,
      icon: <SafetyOutlined />,
      label: "Patrol",
      color: "#52c41a"
    },
    {
      key: 3,
      icon: <ClockCircleOutlined />,
      label: "Time",
      color: "#fa8c16"
    },
    {
      key: 4,
      icon: <FileTextOutlined />,
      label: "Report",
      color: "#722ed1"
    },
    {
      key: 5,
      icon: <AppstoreOutlined />,
      label: "Central",
      color: "#eb2f96"
    }
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 mobile-bottom-nav border-t border-gray-200 shadow-lg z-50 md:hidden">
      <div className="flex justify-around items-center py-2">
        {navItems.map((item) => (
          <button
            key={item.key}
            onClick={() => handleSystemChange(item.key)}
            className={`flex flex-col items-center justify-center p-2 rounded-lg transition-all duration-200 ${
              selectedSystem === item.key 
                ? 'bg-blue-50 text-blue-600' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
            style={{
              minWidth: '60px',
              minHeight: '50px'
            }}
          >
            <div 
              className={`text-lg mb-1 ${
                selectedSystem === item.key ? 'scale-110' : ''
              } transition-transform duration-200`}
              style={{
                color: selectedSystem === item.key ? item.color : 'inherit'
              }}
            >
              {item.icon}
            </div>
            <span className="text-xs font-medium">
              {item.label}
            </span>
            {selectedSystem === item.key && (
              <div 
                className="w-4 h-1 rounded-full mt-1"
                style={{ backgroundColor: item.color }}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileBottomNav;